export default __webpack_public_path__ + "static/media/confident.81f8b5e2.png";